import Swal from 'sweetalert2';
import { api } from "./useApi";

export const authApi = () => ({
  validateToken: async () => {
    try {
      const response = await api.post("/usuario/verifica_sessao");
      return response.data;
    } catch (error) {
      return false;
    }
  },

  signin: async (email: string, senha: string, forcarLogin: boolean = false) => {
    try {
      const responseLogin = await api.post("/login/login", { email, senha, forcar_login: forcarLogin });
      return responseLogin.data;
    } catch (error: any) {
      if ((error.code === 'ERR_NETWORK' && error.request.status === 0) || error.response.data === 'BANCO_OFF') {
        Swal.fire({
          title: "Oops...",
          html: `
          <div style="text-align: justify; padding-top: 15px;">
          A infraestrutura do Conecta Venda está passando por uma manutenção programada. Sentimos muito pelo inconveniente. Contamos com a sua compreensão, estamos empenhados e trabalhando para que tudo ocorra da melhor maneira possível.
          </div>
        `,
          icon: "warning",
          confirmButtonText: "Ok"
        });
      } else {
        return error;
      }
    }
  },

  verificar2FA: async (desafio: string, codigo: string) => {
    try {
      const response = await api.post("/login/verificar_2fa", { desafio, codigo });
      return response.data;
    } catch (error: any) {
      return error;
    }
  },

  solicitarRedefinicaoSenha: async (email: string) => {
    try {
      const response = await api.post("/usuario/verifica_usuario_redefinir_senha", { email });
      return response.data;
    } catch (error: any) {
      return error?.response?.data ?? null;
    }
  },

  verificaHashRedefinirSenha: async (hash: string) => {
    try {
      const response = await api.post("/usuario/verifica-hash-redefinir-senha", { hash });
      return response.data;
    } catch (error: any) {
      return error?.response?.data ?? null;
    }
  },

  redefinirSenha: async (hash: string, senha: string, confirmar_senha: string) => {
    try {
      const response = await api.post("/usuario/redefinir-senha", { hash, senha, confirmar_senha });
      return response.data;
    } catch (error: any) {
      return error?.response?.data ?? null;
    }
  },

  getPermissoes: async () => {
    let response: Array<number> = [];

    await api.post("/permissoes/permissoes_usuario").then(
      (res) => {
        response = Object.keys(res.data).map((key) => Number(key));
      },
      (err) => {
        console.log("err", err);
      },
    );

    return response;
  },
  getCustomizado: async () => {
    try {
      const response = await api.post("/permissoes/customizado");
      return !!response.data?.customizadas;
    } catch (error) {
      return false;
    }
  },
  getPermissoesPlanos: async () => {
    const response = await api.post("/plano_permissoes/select-permissoes")
    return response.data;
  },

  logout: async () => {
    const response = await api.post("/login/logout");
    return response.data;
  },
  session_reload: async () => {
    const response = await api.post("/usuario/session_reload");
    return response.data;
  },
});
